<template>
  <div class="tw-w-full tw-max-w-lg tw-rounded-lg tw-bg-light-gray tw-p-5 tw-text-center">
    <p class="tw-mb-4 tw-font-atten-bold tw-text-onyx">
      How would you rate your Winona experience so far?
    </p>
    <div class="tw-flex tw-flex-wrap tw-justify-center tw-gap-2">
      <button
        v-for="i in 10"
        :key="i"
        type="button"
        class="tw-h-9 tw-w-9 tw-rounded-md tw-border tw-border-lavender-purple tw-text-sm tw-transition-colors"
        :class="value === i
          ? 'tw-bg-lavender-purple tw-text-white'
          : 'tw-bg-white tw-text-lavender-purple'"
        @click="select(i)"
      >
        {{ i }}
      </button>
    </div>
  </div>
</template>

<script>
/**
 * NPS-style 1-10 rating. Controlled component: bind with `v-model`.
 * Submission to AnalyticsService is the parent's responsibility (see exit.vue).
 */
export default {
  name: 'FollowupV7Rating',

  props: {
    value: {
      type: Number,
      default: null,
    },
  },

  methods: {
    select(rating) {
      this.$emit('input', rating);
    },
  },
};
</script>
